<template>
  <el-dialog
      title="Chuyển đổi dữ liệu điểm danh sang V4"
      :visible.sync="dialogVisible"
      width="650px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <section v-loading="isLoading">
      <!-- FORM NHẬP LIỆU -->
      <div class="shift-card">
        <div class="card-sub-title">
          <i class="el-icon-s-operation"></i> Thông tin chuyển đổi
        </div>

        <el-form :model="form" :rules="rules" ref="migrateForm" label-position="top" size="small">
          <el-form-item label="Trường" prop="idSchool">
            <el-select
                v-model="form.idSchool"
                placeholder="Chọn trường"
                style="width: 100%"
                filterable
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.id+' - '+item.schoolName"
              />
            </el-select>
          </el-form-item>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Từ ngày" prop="fromDate">
                <el-date-picker
                    v-model="form.fromDate"
                    type="date"
                    placeholder="Chọn ngày bắt đầu"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Đến ngày" prop="toDate">
                <el-date-picker
                    v-model="form.toDate"
                    type="date"
                    placeholder="Chọn ngày kết thúc"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="warning-note">
          <i class="el-icon-warning-outline"></i>
          <span>Dữ liệu V4 đã có sẽ bị ghi đè. Không nên chọn khoảng thời gian quá 3 tháng trong 1 lần.</span>
        </div>
      </div>

      <!-- KẾT QUẢ -->
      <div class="shift-card" v-if="result !== null">
        <div class="card-sub-title">
          <i class="el-icon-data-analysis"></i> Kết quả chuyển đổi
        </div>

        <div class="result-summary">
          <div class="summary-box total">
            <span class="num">{{ result.totalRecords }}</span>
            <span class="lbl">Tổng bản ghi</span>
          </div>
          <div class="summary-box skipped">
            <span class="num">{{ result.skippedRecords }}</span>
            <span class="lbl">Bỏ qua ⏭️</span>
          </div>
          <div class="summary-box success">
            <span class="num">{{ result.migratedRecords }}</span>
            <span class="lbl">Thành công ✅</span>
          </div>
          <div class="summary-box failed">
            <span class="num">{{ result.failedRecords }}</span>
            <span class="lbl">Lỗi ❌</span>
          </div>
        </div>

        <div class="result-legend">
          <div class="legend-title">
            <i class="el-icon-info"></i>
            <span>Chú thích</span>
          </div>
          <div class="legend-item">
            <strong>Tổng bản ghi:</strong>
            số bản ghi điểm danh tìm thấy theo trường và khoảng ngày đã chọn.
          </div>
          <div class="legend-item">
            <strong>Bỏ qua:</strong>
            số bản ghi không có dữ liệu điểm danh nên không được chuyển đổi.
          </div>
          <div class="legend-item">
            <strong>Thành công:</strong>
            số bản ghi đã được chuyển đổi sang dữ liệu V4.
          </div>
          <div class="legend-item">
            <strong>Lỗi:</strong>
            số bản ghi không chuyển đổi được, cần kiểm tra và có thể chạy lại.
          </div>
          <div class="legend-note">
            Tổng bản ghi thường bằng Bỏ qua + Thành công + Lỗi.
          </div>
        </div>

        <div class="result-message" :class="{'has-error': result.failedRecords > 0}">
          <i :class="result.failedRecords > 0 ? 'el-icon-warning' : 'el-icon-success'"></i>
          <span>{{ result.message }}</span>
        </div>
      </div>
    </section>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog">
        <i class="el-icon-circle-close"/> Đóng
      </el-button>
      <el-button type="primary" size="medium" :loading="isLoading" @click="handleMigrate">
        <i class="el-icon-refresh"/> Chuyển đổi
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import MigrationAttendanceService from "@/attendance_v3/services/MigrationAttendanceService";

export default {
  name: "MigrationAttendanceDialog",
  props: {
    dialogVisible: { type: Boolean, default: false, required: true },
    schoolList: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        idSchool: null,
        fromDate: null,
        toDate: null,
      },
      result: null,
      isLoading: false,
      rules: {
        idSchool: [{ required: true, message: "Vui lòng chọn trường", trigger: "change" }],
        fromDate: [{ required: true, message: "Vui lòng chọn ngày bắt đầu", trigger: "change" }],
        toDate: [{ required: true, message: "Vui lòng chọn ngày kết thúc", trigger: "change" }],
      },
    };
  },
  methods: {
    handleMigrate() {
      this.$refs.migrateForm.validate((valid) => {
        if (!valid) return;

        if (this.form.fromDate > this.form.toDate) {
          this.$message({ message: "Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc", type: "error" });
          return;
        }

        const from = new Date(this.form.fromDate);
        const to = new Date(this.form.toDate);
        const diffMonths = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
        if (diffMonths > 3) {
          this.$message({ message: "Khoảng thời gian không được quá 3 tháng", type: "error" });
          return;
        }

        this.$confirm(
            "Dữ liệu V4 đã có sẽ bị ghi đè. Bạn có chắc chắn muốn chuyển đổi?",
            "Xác nhận chuyển đổi",
            { confirmButtonText: "Xác nhận", cancelButtonText: "Huỷ bỏ", type: "warning", closeOnClickModal: false }
        ).then(() => {
          this.executeMigrate();
        }).catch(() => {});
      });
    },

    async executeMigrate() {
      this.isLoading = true;
      this.result = null;
      try {
        const res = await MigrationAttendanceService.migrate({
          idSchool: this.form.idSchool,
          fromDate: this.form.fromDate,
          toDate: this.form.toDate,
        });
        this.result = res.data.data;
        if (this.result.failedRecords > 0) {
          this.$message({ message: "Có bản ghi lỗi, vui lòng kiểm tra lại", type: "warning" });
        } else if (this.result.totalRecords === 0) {
          this.$message({ message: "Không tìm thấy dữ liệu điểm danh theo filter", type: "info" });
        } else {
          this.$message({ message: "Chuyển đổi dữ liệu thành công", type: "success" });
        }
      } catch (err) {
        const msg = err?.response?.data?.message || "Có lỗi xảy ra khi chuyển đổi";
        this.$message({ message: msg, type: "error" });
      } finally {
        this.isLoading = false;
      }
    },

    closeDialog() {
      this.result = null;
      this.$refs.migrateForm && this.$refs.migrateForm.resetFields();
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.shift-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #eef2f6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  margin-bottom: 16px;
}

.card-sub-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-note {
  margin-top: 16px;
  padding: 10px 14px;
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  font-size: 13px;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 8px;

  i { font-size: 16px; color: #d97706; }
}

.result-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;

  .summary-box {
    padding: 14px 12px;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &.total { background-color: #f0f9ff; border: 1px solid #bae6fd; .num { color: #0369a1; } }
    &.success { background-color: #f0fdf4; border: 1px solid #bbf7d0; .num { color: #166534; } }
    &.skipped { background-color: #fffbeb; border: 1px solid #fde68a; .num { color: #92400e; } }
    &.failed { background-color: #fef2f2; border: 1px solid #fecaca; .num { color: #991b1b; } }

    .num { font-size: 22px; font-weight: 700; }
    .lbl { font-size: 12px; color: #64748b; }
  }
}

.result-message {
  padding: 12px 16px;
  background-color: #f0fdf4;
  border-left: 4px solid #22c55e;
  border-radius: 0 8px 8px 0;
  color: #166534;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  &.has-error { background-color: #fef2f2; border-left-color: #ef4444; color: #991b1b; }
}

.result-legend {
  margin-bottom: 16px;
  padding: 12px 14px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;

  .legend-title {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;

    i { color: #2563eb; }
  }

  .legend-item { margin-top: 3px; }

  strong { color: #334155; }

  .legend-note {
    margin-top: 7px;
    color: #64748b;
    font-style: italic;
  }
}

::v-deep .el-dialog { border-radius: 16px; overflow: hidden; }
::v-deep .el-dialog__header { background: linear-gradient(135deg, #2563eb, #1d4ed8); padding: 18px 24px !important; }
::v-deep .el-dialog__title { color: white !important; font-size: 19px !important; font-weight: 600; }
::v-deep .el-dialog__headerbtn .el-dialog__close { color: white !important; font-size: 22px; }
::v-deep .el-dialog__body { max-height: 74vh; overflow-y: auto; background: #f8fafc; padding: 20px 24px !important; }
::v-deep .el-dialog__footer { background: #f1f5f9; padding: 14px 24px !important; border-top: 1px solid #e2e8f0; }
</style>
